import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconMessage3 = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="orange">
      <Path fillRule="evenodd" clipRule="evenodd" d="M4.68 8.503a6.946 6.946 0 0 1 5.177-5.177 12.35 12.35 0 0 1 5.64 0 6.947 6.947 0 0 1 5.177 5.177 12.35 12.35 0 0 1 0 5.64 6.946 6.946 0 0 1-5.177 5.177 12.347 12.347 0 0 1-5.64 0 6.94 6.94 0 0 1-1.77-.681 2.547 2.547 0 1 1-2.726-2.725 6.94 6.94 0 0 1-.68-1.77 12.35 12.35 0 0 1 0-5.641ZM8.5 9.795c0-.337.274-.611.612-.611h3.056a.611.611 0 0 1 0 1.222H9.112a.611.611 0 0 1-.611-.61Zm1.63 2.445a.611.611 0 1 0 0 1.222h5.093a.611.611 0 0 0 0-1.222H10.13Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
